<template>
  <div class="content">
    <div :class="{bg: true, empty: list.length === 0}" ref="list">
      <newTopicFilter @calChange="calChange" ref="interviewFilter" @getData="getFilter" :foreman_config="foreman_config" :has_foreman_opt_role="has_duty_info_set_role" :showinfo="true" :showCreate="showCreate" />
      <div class="list">
        <div class="titles">
          <span class="icon"></span>
          <span class="theme">选题名称</span>
          <span class="people">执行人</span>
          <span class="depart">部门</span>
          <span class="discuss">讨论区</span>
          <span class="progress">进展更新</span>
          <span class="platform">分发平台</span>
          <span class="monitor">值班长意见</span>
          <span class="edit"></span>
        </div>
        <empty :mTop="30" :msg="`暂无选题库数据`" v-if="list && list.length === 0" />
        <div class="items" v-for="(i, d) in list" :key="d">
          <div class="item">
            <span class="icon">
              <i v-show="i.is_important == 1" class="top"></i>
              <i v-show="i.view_scope == 1" class="lock"></i>
            </span>
            <span class="theme" @click="goDetail(i.id)">
              <p class="words" :title="i.title">
                {{i.title}}
              </p>
              <span class="msgIcon" v-if="i.remark && tagMark">
                <img src="@assets/img/interview/msg.svg" alt="msg">
                <p class="msgContent">
                  {{i.remark}}
                </p>
              </span>
              <img v-show="i.is_new == 1" src="@assets/img/interview/new.svg" alt="new">
              <img src="@assets/img/interview/alert.svg" alt="warn" v-if="i.has_change - 0 === 1">
            </span>
            <span class="people">{{i.executor_name || '无'}}</span>
            <span class="depart">{{i.depart_name}}</span>
            <span class="discuss">
              <i @click="openDiscussBox(i.title, i.id)" :class="{new: i.talkarea_is_red == 1}"></i>
            </span>
            <span class="progress">
              <span :title="i.process_info">{{ i.process_info }}</span>
              <i @click="openProgressUpdate(i.title, i.id)">{{i.process_info ? '查看' : '新增'}}</i>
            </span>
            <span class="platform">
              <p v-for="item in i.foreman_issue_platform" :class="{blue: item == '电视', purple: item == '新媒体', green: item == '直播', pink: item == '海报'}">{{item}}</p>
            </span>
            <span :title="i.foreman_view" class="monitor">{{i.foreman_view}}</span>
            <span class="edit">
              <i @click="editForeman(i)" v-show="has_foreman_opt_role">编辑</i>
            </span>
          </div>
        </div>
      </div>
      <pages :page_count="page.page_count" :index="page.pageIndex" :total="page.total"></pages>
    </div>
  </div>
</template>

<script>
import newTopicFilter from '@components/newTopicFilter'
import pages from '@components/pages'
import {apis} from '@common/config'
import common from '@common/common'
import empty from '@components/empty'
import dc from '@common/dc'

export default {
  name: 'allInterviews',
  components: {
    newTopicFilter, pages, empty
  },
  data() {
    return {
      foreman_config: {},
      has_foreman_opt_role: false,
      has_duty_info_set_role: false,
      has_talkarea_edit_role: false,
      filters: [],
      page: {
        pageSize: 10,
        pageIndex: 1,
        page_count: 0,
        total: 0
      },
      list: [],
      searchOptions: {},
      filterOptions: {},
      showCreate: false,
      tagMark: false // 是否显示图标tag
    }
  },
  methods: {
    calChange(date){
      let dateList = document.querySelectorAll('.mx-datepicker.topicDate .cell')
      if(dateList && dateList.length > 0){
        dateList.forEach(item => {
          item.classList.remove('hasTopicIcon')
        })
      }
      let info = {
        date: date
      }
      common.myFetch(apis.newTopicDays,info).then(res => {
        if(res){
          this.getALreadyTopic(res)
        }
      })
    },
    getALreadyTopic(list) {

      let dateList = document.querySelectorAll('.mx-datepicker.topicDate .cell')
      if(dateList && dateList.length > 0){
        dateList.forEach(item => {
          let date = item.getAttribute('title');
          if(date){
            list.forEach(items => {
              if(date == items){
                item.classList.add('hasTopicIcon')
              }
            })
          }
        })
      }
    },
    openDiscussBox(title, id) {
      this.$discussBox({title, id, has_talkarea_edit_role: this.has_talkarea_edit_role}).then(res => {
        if(res){
          this.getList()
        }
      })
    },
    openProgressUpdate(title, id) {
      this.$progressUpdate({title, id}).then(res => {
        if(res){
          this.getList()
        }
      })
    },
    editForeman(i) {
      let foreman_issue_platform = '';
      foreman_issue_platform = i.foreman_issue_platform.join(',')
      let info = {
        id: i.id,
        foreman_view: i.foreman_view,
        foreman_issue_platform: foreman_issue_platform,
        arr: i.foreman_issue_platform
      }
      this.$foremanInfo(info).then(res => {
        if(res){
          this.getList()
        }
      })
    },
    showCard(id, e) {
      if (id == 0) return
      
      const el = e.target

      this.$card(id, el)
    },
    goClue(i) {
      // 去创建线索页
      // const d = {
      //   id: i.id,
      //   title: i.title
      // }
      //
      // this.$router.push({
      //   name: 'creatClue',
      //   params: {
      //     interview: d
      //   }
      // })
      dc.setItv(i)

      common.jump('/creatClue', true)

      setTimeout(() => {
        dc.delItv()
      }, 0)
    },
    goDetail(i) {
      // 跳转详情页
      // this.$router.push({
      //   path: '/interviewDetail',
      //   query: {
      //     r: i
      //   }
      // })

      common.jump(`/newTopicDetail?r=${i}`, true)
    },
    getList(keyWord) {
      // 获取列表
      const id = this.$route.params.id

      const info = {
        idstring: id,
        search_option: '',
        key_words: '',
        start: '',
        end: '',
        status: '',
        has_material: '',
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      if(keyWord == 'noKeyWord'){
        this.searchOptions.key_words = ''
      }else{  
        this.searchOptions.key_words = this.$store.state.keyWord
      }

      Object.assign(info, this.searchOptions, this.filterOptions)

      common.myFetch(apis.newTopicList, info)
      .then((data) => {
        this.list = data.list
        this.generateSearchs(data.params.top_search.option.list)
        this.generateFilters(data.params.list_search)
        this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
        this.$set(this.page, 'total', data.page.row_count - 0)
        this.showCreate = data.has_add_role
        this.foreman_config = data.foreman_config
        this.has_foreman_opt_role = data.has_foreman_opt_role
        this.has_duty_info_set_role = data.has_duty_info_set_role
        this.has_talkarea_edit_role = data.has_talkarea_edit_role

        this.$nextTick(() => {
          this.whetherShowTagMark()
        })
      })
    },
    generateFilters(data) {
      // 整理过滤条件数据
      this.$refs.interviewFilter.filters.forEach((i) => {
        data.forEach((j) => {
          if (i.key === j.key) {
            j.expand = !!i.expand
          }
        })
      })

      if(this.filters.length == 0){
        console.log(123123)
        this.filters = data.filter((i) => {
          return i.key !== 'start' && i.key !== 'end'
        })

        this.filters.forEach(el => {
          if(el.list && el.list.length > 0){
            el.list.forEach(el1 => {
              el1.selected = false
            })
          }
        })

        this.$refs.interviewFilter.filters = this.filters
      }
    },
    generateSearchs(data) {
      // 整理搜索栏数据
      const types = data.map((i) => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        }
      })

      const filterData = {
        types: types,
        callback: (o) => {
          this.getSearch(o)
        }
      }
      this.postSearch(filterData)
    },
    getFilter(data) {
      // 接收过滤框数据
      this.filterOptions = data
      this.page.pageIndex = 1
      this.getList()
    },
    getSearch(d) {
      // 接收搜索框数据
      this.searchOptions = d
      this.getList()
    },
    postSearch(data) {
      // 发送搜索框数据
      this.$emit('filterData', data)
    },
    whetherShowTagMark() {
      // 计算宽度，是否显示标题上的标签
      const list = this.$refs.list
      if (!list || !list.getBoundingClientRect()) return
      const listWidth = list.getBoundingClientRect().width
      const limitWidth = 1100

      if (listWidth <= limitWidth) {
        this.tagMark = true
      } else {
        this.tagMark = false
      }
    },
    watchResize() {
      // 监听宽度变化
      window.addEventListener('resize', () => {
        this.whetherShowTagMark()
      })
    }
  },
  mounted() {
    this.getList('noKeyWord')
    // 默认渲染当天数据
    // this.$refs.interviewFilter.initDate()
    this.watchResize()
  }
}
</script>

<style lang="less" scoped src="@assets/css/newTopic/allInterviews.less"></style>

<style lang="less">
.hasTopicIcon {
  position: relative;

  &::after {
    position: absolute;
    bottom: 2px;
    left: 50%;
    transform: translateX(-50%);
    display: block;
    content: '';
    background: #41b48c !important;
    width: 5px;
    height: 5px;
    border-radius: 50%;
  }
}
</style>
